export const strings = {
  save: '保存',
  foodInfo: 'フード情報',
}

export const foodInfoTableContent = {
  name: '名前',
  price: '価格',
}
